<div *ngIf="!tpl" [innerHTML]="text"></div>
<ng-template [ngTemplateOutlet]="tpl"></ng-template>